import React, { useState, useEffect } from "react";
import Footer from "../../footer";
import AdminSidebar from "../sidebar";
import { getDataWithTypeForSelect } from "../../../lib/parameters"
import { addData ,updateData,getIdData} from "../../../lib/collegerank"
import { useNavigate, useParams } from 'react-router-dom';

export default function InstructorDesiredCollegesEdit() {

  const [cname, setCname] = useState();
  const [parameters, setParameters] = useState();
  const [ranks, setRanks] = useState([]);
  const navigate = useNavigate();
  let { slug } = useParams();


  function getRank(key) {
    //console.log("ranks",ranks);
    if (slug !== "Add")
    {
      //console.log("key",key);
    const result = Object.entries(ranks).filter(item => item[0] === key.toString() )
    //console.log("key",result);
      return result[0][1];
    }
    else return null;
  }

  async function GetParameterData() {
    const parameterData = await getDataWithTypeForSelect("DESIRED_COLLEGES");
    setParameters(parameterData);
    //console.log("Rank",ranks);

  
    //const collage = await getIdData(2);
    //console.log("collage",collage[0].rankvalue);
    //const obj = JSON.parse(collage[0].rankvalue);
    //setRanks(obj);
 
    //console.log("parameterData",parameterData);
    /*
    console.log("ranks", obj);
    Object.entries(obj).forEach(entry => {
      const [key, value] = entry;
      console.log(key, value);
      if (key==="56") console.log(" 56 value  " , value);
    });

    const result = Object.entries(obj).filter(entry => 
      {
        const [key, value] = entry;
        if (key==="57") console.log(" 57 value 2 " , value);
        //console.log("entry",entry);
      }
      )
      */
    //console.log("result",result) 
    
  }

  async function GetData(id) {
    const collage = await getIdData(id);
    const obj = JSON.parse(collage[0].rankvalue);
    setCname(collage[0].collegename)
    //console.log("collage",collage , id);
    setRanks(obj);

    GetParameterData();
  }

  const handleSubmit = async (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      const formJson = Object.fromEntries(formData.entries());
      console.log("form",formJson);
      const formel = [...formData.entries()];
      console.log("formel",formel);

      Object.entries(formel).forEach(entry => {
        const [key, value] = entry;
        //console.log(key, value[0], value[1]);
      });


     // console.log("Result",getRank("56"));
/*
      const form = e.target;
      const formData = new FormData(form);
      const formJson = Object.fromEntries(formData.entries());
      console.log("formJson",formJson);
  */
      if (slug === "Add") {
        console.log("Add");
      await addData({
        collegename: cname,
        rankvalue: formJson
      });
    }
    else {
      console.log("Update");
      await updateData({
        id: slug,
        collegename: cname,
        rankvalue: formJson
      });
    }

    navigate("/instructor/instructor-desiredcolleges");
 /*
    if (slug === "Add") {
      console.log("Add");
      await addData({
        pname: parameter,
        type: type,
        order: order
      });
    }
    else {
      console.log("Update");
      await updateData({
        id: slug,
        pname: parameter,
        type: type,
        order: order
      });
    }

    navigate("/admin-params");
  */
  };

  useEffect(() => {
    //navigate("/admin-params");
    if (slug !== "Add") {
      GetData(slug);
    }
    else
   { GetParameterData();}
    
  }, [slug])


  return (
            <div className="col-xl-12 col-md-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-2">
                  <div className="profile-heading p-2">
                    <h3>{slug === "Add" ? "Add College" : "Update College" }</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                      <div className="row">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              College Name
                            </label>
                            <input
                              type="text"
                              name = "cname"
                              value={cname}
                              onChange={(e) => setCname(e.target.value)}
                              className="form-control"
                              placeholder="Enter College Name"
                              required
                            />
                          </div>
                        </div>
                        <form method="post"  onSubmit={handleSubmit}>
                        <div className="col-9">
                          <div className="form-group"></div>
                          </div>
                        <div className="col-9">
                          <div className="form-group">
                          <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th></th>
                            <th>Rank</th>
                          </tr>
                        </thead>
                        <tbody>
                        {parameters ? parameters.map(function (prm) {
                          return (
                            <tr key={prm.value}>
                            <td>{prm.label}</td>
                            <td></td>
                            <td>
                              {/*}
                              <CollegeRankSelect value={getRank(prm.value)}  name={prm.value} setValue={setCname}/>
                          {*/}
                           <div className="select-container">
                            <select
                                name={prm.value}
                                defaultValue={getRank(prm.value)}
                                className="select-box" >
                                  <option value={0}>{0}</option>
                                  <option value={1}>{1}</option>
                                  <option value={2}>{2}</option>
                                  <option value={3}>{3}</option>
                            </select>
                            <div className="icon-container">
                                <i className="fa-solid fa-chevron-down"></i>
                            </div>
                        </div>
                            </td>
                          </tr>
                          ) 
                        }) : ""}
                        </tbody>
                      </table>
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            {slug === "Add" ? "Add Parameter" : "Update Parameter" }
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                        </form>
                      </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
